import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);
function dataDownline(params) {
	return client.post("user/affiliate/data-downline", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function historyCoinGen(params) {
	return client.post("user/transaction/history-coin-gen", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function checkoutTrxFullCoinGen(params) {
	return client.post("user/transaction/check-out-full-coin-gen", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function checkoutTrx(params) {
	return client.post("user/transaction/check-out", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkoutTrxStore(params) {
	return client.post("user/transaction/check-out-store", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkoutTrxVABCA(params) {
	return client.post("user/transaction/check-out-va", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getTransaction(params) {
	return client.get("user/transaction/data", {
		params: params,
	});
}

function getTransactionDetail(params) {
	return client.get("user/transaction/detail", {
		params: params,
	});
}

function cancelTransaction(params) {
	return client.post("user/transaction/cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelBank(params) {
	return client.post("user/transaction/cancel-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function cancelStore(params) {
	return client.post("user/transaction/cancel-store", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelVA(params) {
	return client.post("user/transaction/cancel-va", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function receiveTransaction(params) {
	return client.post("user/transaction/receive", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadConfirmation(params) {
	return client.post("user/transaction/pay", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

export default {
	dataDownline,
	checkoutTrx,
	checkoutTrxStore,
	checkoutTrxVABCA,
	getTransaction,
	getTransactionDetail,
	cancelTransaction,
	cancelBank,
	cancelStore,
	cancelVA,
	receiveTransaction,
	uploadConfirmation,
	checkoutTrxFullCoinGen,
	historyCoinGen,
};